import { render, staticRenderFns } from "./Pallet.vue?vue&type=template&id=25338010&scoped=true&"
import script from "./Pallet.vue?vue&type=script&lang=js&"
export * from "./Pallet.vue?vue&type=script&lang=js&"
import style0 from "./Pallet.vue?vue&type=style&index=0&id=25338010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25338010",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25338010')) {
      api.createRecord('25338010', component.options)
    } else {
      api.reload('25338010', component.options)
    }
    module.hot.accept("./Pallet.vue?vue&type=template&id=25338010&scoped=true&", function () {
      api.rerender('25338010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/common/Pallet.vue"
export default component.exports